import Vue from 'vue'
import App from './App.vue'
import 'vant/lib/index.css'
import store from './store'
import router from './router'
import '@/assets/style/reset.less'
import Vant from 'vant'
import { Lazyload } from 'vant'
import {DatePicker, Select, Option} from "element-ui"

import 'amfe-flexible'


Vue.use(Vant)
Vue.use(Lazyload,{
    lazyComponent: true,
    preload:'1.6',
    listenEvents: [ 'scroll','touchmove','wheel','touchstart']
})
Vue.use(DatePicker)
Vue.use(Select)
Vue.use(Option)
Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount('#app')
